import React from "react";
import "./styles/Genre.css";

function Genre() {
  return (
    <div className="genre--container">
      <h6 className="genre--title">Genre/Zhanri</h6>
      <div className="genres">
        <button>Adoration</button>
        <button>Middle</button>
        <button>Worship</button>
      </div>
    </div>
  );
}

export default Genre;
